var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"food-nav-link text-white font-bold py-1",class:_vm.state,attrs:{"href":'#'+ _vm.uuid}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }